export const ROUTES = {
  DEFAULT: {
    title: "",
    key: "default",
    link: "/"
  }, 
  LOGIN: {
    title: "Login",
    key: "login",
    link: "/login",
  },
  SEND_OTP: {
    title: "Send OTP",
    key: "sendotp",
    link: "/sendOtp",
  },
  VERIFY_OTP: {
    title: "Verify OTP",
    key: "verifyotp",
    link: "/verifyOtp",
  },
  CONFIRM_REGISTRATION: {
    title: "Confirm Registration",
    key: "registrationconfirm",
    link: "/registrationConfirm",
  },
  PROFILE: {
    title: "Profile",
    key: "profile",
    link: "/profile",
  },
  REGISTER: {
    title: "Add User",
    key: "addUser",
    link: "/addUser",
  },
  CHANGE_ORG: {
    title: "Change Organisation",
    key: "changeOrganisation",
    link: "/changeOrganisation",
  },
  GRAFANA_LOGIN: {
    title: "Enable Charts",
    key: "",
    link: "/",
  },
  LOGOUT: {
    title: "Logout",
    key: "logout",
    link: "/logout",
  },
  DEALER_SLIDESHOW: {
    title: "SlideShow",
    key: "dealerSlideShow",
    link: "/dealerSlideShow",
  },
  EXPORT: {
    title: "Download",
    key: "download",
    link: "/download",
  },
  HOME: {
    title: "Home",
    key: "home",
    link: "/home",
  },
  ALERTS: {
    title: "Alerts",
    key: "alerts",
    link: "/alerts",
  },
  OPERATIONAL_PARAMETERS: {
    title: "Operational Parameters",
    key: "operationalParameters",
    link: "/operationalParameters",
  },
  ACCESS_DENIED: {
    title: "Access Denied",
    key: "accessDenied",
    link: "/accessDenied",
  },
  PRODUCT_HEALTH: {
    title: "Product Health",
    key: "productHealth",
    link: "/productHealth",
  },
  VEHICLE_INFORMATION: {
    title: "Vehicle Information",
    key: "vehicleInformation",
    link: "/vehicleInformation",
  },
  VEHICLE_ANALYTICS: {
    title: "Vehicle Analytics",
    key: "vehicleAnalytics",
    link: "/vehicleAnalytics",
  },
  COMPETITOR: {
    title: "Competitor Pulse",
    key: "competitors",
    link: "/competitors"
  },
  VEHICLE_HEALTH: {
    title: "Vehicle Health",
    key: "vehicleHealth",
    link: "/vehicleHealth",
  },
  BATTERY_PERFORMANCE: {
    title: "Battery Performance",
    key: "batteryPerformance",
    link: "/batteryPerformance",
  },
  DEALER_SERVICE: {
    title: "Service",
    key: "dealerService",
    link: "/dealerService",
  },
  DEALER_PERFORMANCE: {
    title: "Performance",
    key: "dealerPerformance",
    link: "/dealerPerformance",
  },
  DEALER_EXECUTIVE: {
    title: "Executive",
    key: "dealerExecutive",
    link: "/dealerExecutive",
  },
  FORGOT_PASSWORD: {
    title: "Forgot Password",
    key: "forgotPassword",
    link: "/forgotPassword",
  },
  CHANGE_PASSWORD: {
    title: "Change Password",
    key: "changePassword",
    link: "/changePassword",
  },
  EOL_TESTS: {
    title: "EOL Tests",
    key: "eolTests",
    link: "/eolTests",
  },
  EOL_ANALYTICS: {
    title: "EOL Analytics",
    key: "eolAnalytics",
    link: "/eolAnalytics",
  },
  TEST_RIDES: {
    title: "Test Rides",
    key: "testRides",
    link: "/testRides",
  },
  FLEET_MONITOR: {
    title: "Fleet Monitor",
    key: "fleetMonitor",
    link: "/fleetMonitor",
  },
  FLEET_ANALYTICS: {
    title: "Fleet Analytics",
    key: "fleetAnalytics",
    link: "/fleetAnalytics",
  },
  TEST_RIDES_COMPARISON: {
    title: "Test Rides Comparison",
    key: "testRidesComparison",
    link: "/testRidesComparison",
  },
  SPEAK_WITH_DATA: {
    title: "Speak with Data",
    key: "speakWithData",
    link: "/speakWithData",
  },
};

export const LIVE_PAGE_LIST = [ROUTES.HOME.key, ROUTES.ALERTS.key];
export const DASHBOARD_MENU_LIST = [ROUTES.VEHICLE_ANALYTICS.key, ROUTES.VEHICLE_HEALTH.key, ROUTES.BATTERY_PERFORMANCE.key, ROUTES.FLEET_MONITOR.key, ROUTES.FLEET_ANALYTICS.key, ROUTES.EOL_TESTS.key, ROUTES.EOL_ANALYTICS.key, ROUTES.TEST_RIDES.key, ROUTES.TEST_RIDES_COMPARISON.key, ROUTES.SPEAK_WITH_DATA.key];
export const DISPLAYS_MENU_LIST = [ROUTES.PRODUCT_HEALTH.key, ROUTES.OPERATIONAL_PARAMETERS.key];
export const USER_MENU_LIST = [ROUTES.PROFILE.key, ROUTES.REGISTER.key, ROUTES.CHANGE_ORG.key];

export const ROLES = {
  ADMIN: "Admin",
  EXECUTIVE: "Executive",
  FLEET_MANAGER: "Fleet Manager",
  TEST_RIDE_ENGINEER: "Test Ride Engineer",
  TEST_ENGINEER: "Test Engineer",
  RIDER: "Rider",
  ERPUSER: "ERPUser",
};

export const ORG_TYPES = {
  ADMINISTRATOR: "ADMINISTRATOR",
  MANUFACTURER: "MANUFACTURER",
  B2B_CUSTOMER: "B2BCUSTOMER",
  DEALER: "DEALER",
};

export const UNITS = {
  KM: "km",
  HOURS: "hrs",
  MILLISECONDS: "ms",
  KM_PER_HR: "km/h",
  METER_PER_CHARGE: "m/C",
  MILLI_AMPERE: "mA",
  KILO_WATTS: "kW",
  KW_HR_PER_KM: "kWh/km",
  SECONDS: "s",
  MINUTES: "m",
  METER: "m",
  KG: "kg",
  PERCENT: "%",
  CELSIUS: "\u2103",
  AMPERE: "A",
  VOLTS: "V",
  METER_PER_SECONDS_SQUARED: "m/s\u00B2",
};

export const BREADCRUMBS = {
  DASHBOARDS: "Dashboards",
  DISPLAYS: "Displays",
  USER: "User",
  HOME: "Home",
  EXPORT: "Download",
  ALERTS: "Alerts",
};

export const WARNINGS = {
  RIDER_LOGIN: "Cannot login as a Rider",
};

export const FORMS = {
  ADD_USER: {
    REQUIRED_FIELDS: {
      FIRST_NAME: "* First Name",
      LAST_NAME: "* Last Name",
      EMAIL: "* Email",
      PASSWORD: "* Password",
      PHONE: "* Phone",
      ROLE: "* Select a Role",
      FLEET: "* Select a Fleet",
      SUBMIT: "Add",
      ADD_ORG: "Add to Organisation",
      BLANK_ERROR: "Cannot be empty",
      INVALID_ERROR: "Invalid input",
      SUCCESS: "User has been added",
    },
  },
};

export const TEST_RIDE = {
  FORM: {
    REQUIRED_FIELDS: {
      RIDER_NAME: "Rider Name",
      RIDER_WEIGHT: "Rider Weight",
      PILLION_RIDER_NAME: "Pillion Rider Name",
      PILLION_RIDER_WEIGHT: "Pillion Rider Weight",
      TOTAL_WEIGHT: "Total Weight",
      GOAL: "Goal",
      OBSERVATION_PARAMETERS: "Observation Parameters",
      START_RIDE: "Start Ride",
      TEMPERATURES: "Temperatures",
      AMBIENT: "Ambient",
      MCU: "MCU",
      MOTOR: "Motor",
      BATTERY: "Battery",
      BATTERY_DETAILS: "Battery Details",
      MANUFACTURER: "Manufacturer",
      CAPACITY: "Capacity",
      MODEL: "Model",
      END_RIDE: "End Ride",
      TOP_SPEED: "Top Speed",
      TIME_RANGE: "Test Drive Time Range",
      START_TIME: "Start Time",
      END_TIME: "End Time",
      STARTING_LOCATION: "Starting Location",
      ENDING_LOCATION: "Ending Location",
      ROAD_CONDITION: "Road Condition",
      TRAFFIC: "Traffic",
      CLIMATE_CONDITION: "Climate Condition",
      FLYOVERS: "Flyovers",
      DISTANCE: "Distance",
      SOC: "SOC",
      VOLTAGE: "Voltage",
      ISSUES: "Issues",
      START_TRIP: "Start of Trip",
      END_TRIP: "End of Trip",
      COMMENTS: "Comments",
      SUBMIT: "Finish",
      BLANK_ERROR: "Cannot be empty",
      INVALID_DATE_ERROR: "Please choose the correct date and time",
      MAXIMUM_RANGE_ERROR: "Can choose upto 10 hours",
    },
  },
  TEST_RIDE_DETAILS: "Test Ride Details",
  BEFORE_RIDE: "Before the Ride",
  AFTER_RICE: "After the Ride",
  BATTERY_DETAILS: "Battery Details",
  ISSUES: "Issues",
  NOTES: "Notes",
};

export const DATE_TIME_PICKER = {
  FILTER_LABLE: {
    FIVE_MINS: "Last 5 mins",
    FIFTEEN_MINS: "Last 15 mins",
    THIRTY_MINS: "Last 30 mins",
    TODAY: "Today",
    YESTERDAY: "Yesterday",
    THIS_WEEK: "This Week",
    LAST_WEEK: "Last Week",
    THIS_MONTH: "This Month",
    LAST_MONTH: "Last Month",
  },
};

export const DEMO_EMAIL = "demo@nichesolv.com";

export const MAP_URLS = {
  OSM: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  CARTO_POSITRON: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
  CARTO_DARK: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
  CARTO_VOYAGER: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png"
}
